import type { JSX } from 'react';
import type { UseFormSetValue } from 'react-hook-form';
import { Checkbox } from '@/components/ui/checkbox';
import { Label } from '@/components/ui/label';
import type { ExperienceFormData } from './ExperienceFormFields';

interface EmploymentCheckboxesProps {
  setValue: UseFormSetValue<ExperienceFormData>;
  isOngoing: boolean;
  isFullTime: boolean;
  isContractor: boolean;
  continuous: boolean;
  isGig: boolean;
}

export function EmploymentCheckboxes({
  setValue,
  isOngoing,
  isFullTime,
  isContractor,
  continuous,
  isGig,
}: EmploymentCheckboxesProps): JSX.Element {
  const check = (field: keyof ExperienceFormData) => (v: boolean | 'indeterminate') =>
    setValue(field, v === true);
  return (
    <>
      <div className="flex items-center space-x-2">
        <Checkbox id="isOngoing" checked={isOngoing} onCheckedChange={check('isOngoing')} />
        <Label htmlFor="isOngoing">Currently working here</Label>
      </div>
      <div className="flex gap-4 flex-wrap">
        <div className="flex items-center space-x-2">
          <Checkbox id="isFullTime" checked={isFullTime} onCheckedChange={check('isFullTime')} />
          <Label htmlFor="isFullTime">Full-time</Label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox
            id="isContractor"
            checked={isContractor}
            onCheckedChange={check('isContractor')}
          />
          <Label htmlFor="isContractor">Contractor</Label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox id="continuous" checked={continuous} onCheckedChange={check('continuous')} />
          <Label htmlFor="continuous">Without significant breaks</Label>
        </div>
        <div className="flex items-center space-x-2">
          <Checkbox id="isGig" checked={isGig} onCheckedChange={check('isGig')} />
          <Label htmlFor="isGig">Gig / Project-based work</Label>
        </div>
      </div>
    </>
  );
}
